document.addEventListener("DOMContentLoaded", function () {
	let id = ".splide-selection-speciale";
	let splideElem = document.querySelector(id);
	if (splideElem) {
		if (splideElem.splideInstance) {
			splideElem.splideInstance.destroy(true);
		}
		const splideInstance = new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: false,
			gap: 8,
			perPage: 2,
			breakpoints: {
				768: {
					perPage: 1,
					arrows: false,
					padding: {
						right: 20,
					},
				},
			},
		}).mount();
		splideElem.splideInstance = splideInstance;
	}
});
